import { AnyTask, Point } from "tm-shared/types";

import { TaskViewModalsContainer } from "@/features/TaskView";
import { QueueProgress } from "@/hooks";
import { ProgressLoader } from "@/shared/feedback";

import { WorkPlanModalType } from "../WorkPlan.types";
import { DayStartedModal } from "./DayStartedModal";
import { ForceStopWorkModal } from "./IncompleteTasksModal";
import { SkipPointModal } from "./SkipPointModal";

interface WorkPlanModalsProps {
    modal: WorkPlanModalType;
    tasksInfoModal: { point: Point; task: AnyTask } | null;
    queueProgress: QueueProgress;
    onCloseModal: () => void;
    onCloseTasksInfoModal: () => void;
}

export const WorkPlanModals = ({
    modal,
    tasksInfoModal,
    queueProgress,
    onCloseModal,
    onCloseTasksInfoModal,
}: WorkPlanModalsProps) => (
    <>
        {modal === "skipPoint" && (
            <SkipPointModal isOpen onClose={onCloseModal} />
        )}

        {modal === "dayStarted" && <DayStartedModal onClose={onCloseModal} />}

        {modal === "forceStopWork" && (
            <ForceStopWorkModal onClose={onCloseModal} />
        )}

        <ProgressLoader
            open={queueProgress.isRunning}
            tasks={queueProgress.tasks}
        />

        <TaskViewModalsContainer
            modal={tasksInfoModal}
            onClose={onCloseTasksInfoModal}
        />
    </>
);
